

import { Component } from '@angular/core';


@Component({

    selector: 'kcc-cmp-Lko',
    templateUrl: './kccLko.component.html', 
   
  })
export class KccLkoComponent{  
    
}





// WEBPACK FOOTER //
// ./src/app/crm/kccLko/kccLko.component.ts